export default class Service {
	static get $inject(){
		return [
			'$state',
			'NotificationService',
			'ApiPanelsService'];
	}

	constructor($state,
	            ApiPanelsService){

		this._$state = $state;
		this._ApiPanelsService = ApiPanelsService;
	}

	// --- Panel ------------------------------------------

	getDectOutputMeasurements(panelId, outputId, interfaceId, durationStr, offset){

		return this._ApiPanelsService._getDectMeasurements(panelId, outputId, interfaceId, durationStr, offset);

	}

	getDectZoneMeasurements(panelId, zoneId, interfaceId, durationStr, offset){

		return this._ApiPanelsService._getDectMeasurements(panelId, zoneId, interfaceId, durationStr, offset);

	}

	getDectOutputLastMeasurements(panelId, outputId, interfaceId){

		return this._ApiPanelsService.getDectOutputLastMeasurements(panelId, outputId, interfaceId);

	}

	getDectZoneLastMeasurements(panelId, zoneId, interfaceId){

		return this._ApiPanelsService.getDectZoneLastMeasurements(panelId, zoneId, interfaceId);

	}
}




/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/services/panel.service.js
 **/